<template>
	<div class="login_mobile">
		<LoginHeader title="手机号登录" desc="未注册的手机号验证后将自动注册" />
		<div class="mobile">
			<base-input
				v-model="mobile"
				placeholder="请输入手机号"
				maxlength="11"
				type="tel"
				clearable
				show-border
				@clear="mobile = ''"
			/>
		</div>
		<div class="agreement">
			<van-popover
				v-model="showPopover"
				:offset="[-7, 8]"
				theme="dark"
				:get-container="getContainer"
				placement="top-start"
			>
				<span class="popover__content">请阅读并勾选页面协议</span>
				<template #reference>
					<van-checkbox v-model="checked"></van-checkbox>
				</template>
			</van-popover>
			<p class="agreement__inner">
				我已阅读并同意
				<span class="primary" @click="$router.push('/agreement/yinsi')">《隐私权政策》</span>
				以及
				<span class="primary" @click="$router.push('/agreement/fuwu')">《服务协议》</span>
			</p>
		</div>
		<div @click="getCodeRoot">
			<van-button type="primary" block :disabled="allowLogin" @click="getCode">获取验证码</van-button>
		</div>
	</div>
</template>

<script>
	import LoginHeader from './login-header.vue'
	export default {
		name: 'login-mobile',
		components: {
			LoginHeader
		},
		data: () => ({
			mobile: '',
			checked: false,
			showPopover: false
		}),
		computed: {
			allowLogin () {
				return !(this.mobile.length === 11)
			}
		},
		methods: {
			getContainer () {
				return document.querySelector('.login');
			},
			getCodeRoot () {
				if (!this.allowLogin) return
				if (this.mobile.trim() === '') {
					this.$toast('请输入手机号')
					return
				}
				if (!this.$reg.isMobile(this.mobile)) {
					this.$toast('请输入正确的手机号')
					return
				}
			},
			// 点击获取验证码
			getCode () {
				if (!this.$reg.isMobile(this.mobile)) {
					this.$toast('请输入正确的手机号')
					return
				}
				// 检测勾选协议
				if (!this.checked) {
					this.showPopover = true
					return
				}

				this.$emit('sendSmsCode', { mobile: this.mobile })
			}
		}
	}
</script>

<style scoped lang="less">
	.login_mobile {
		padding: 0 60px;
		.mobile {
			padding-top: 52px;
		}
		.agreement {
			display: flex;
			align-items: center;
			padding: 64px 0 36px;
			.van-popover__wrapper {
				flex: 0 0 35px;
			}
			.agreement__inner {
				flex: auto;
				padding-left: 8px;
				height: 38px;
				font-family: PingFangSC-Regular;
				font-size: 24px;
				font-weight: normal;
				line-height: 38px;
				color: #8F959E;
			}
		}
	}
	.van-popup { left: 0; }
	.popover__content {
		display: inline-block;
		padding: 23px 24px;
		font-family: PingFangSC-Regular;
		font-size: 28px;
		font-weight: normal;
		line-height: 34px;
	}
</style>
<style lang="less">
	.login_mobile {
		.van-checkbox__icon { font-size: 32px; }
	}
</style>
